import axios from "axios";
import { useRouter } from "next/router";
import Layout from "../../components/layout";
import styles from "./landings.module.scss";
import { servicesNameList } from "../../components/landings/constants";
import OpenGraphTwitterCard from "../../components/seo/OpenGraphTwitterCard";
import { useState } from "react";
import AuthModal from "../../components/AuthModal/AuthModal";
import { useStore } from "../../stores/use_global_state";
import FaqComponentNew from "../../components/FaqComponent/FaqComponentNew";
import getCommonLocales from "../../locales/locales_common";
import LandingSchema from "../../components/landings/landing-schema";
import LandingMain from "../../components/landings/landingMain";

export default function Landing({ post, locale, canonicalLocale }) {
	const { push } = useRouter();
	const dictionary = { ...getCommonLocales(canonicalLocale) };
	const { state, dispatch } = useStore();

	const colorScheme = post?.landing_color_scheme?.data?.attributes?.className || "schemeOne";
	const seo = post.SEO;
	const { Title, Description, Linck_name, Query_params } = seo;

	const serviceData = post.service.data.attributes;

	const thisIsFile = serviceData.Name !== "Image Generator" && serviceData.Name !== "AI Illustration" && serviceData.Name !== "Remove video background";
	const thisIsApp = serviceData.Name === "app";
	const [showAuthModal, setShowAuthModal] = useState(false);

	const isSoon = serviceData.Name === "Soon";

	const handlerClick = (file) => {
		if (!state.isAuth) return setShowAuthModal(true);

		if (thisIsFile) {
			dispatch({ type: "setTemporaryFile", file: file });
			push(`/${serviceData.url_name}/?${Query_params}&file=true`);
		}

		if (!thisIsFile) {
			push(`/${serviceData.url_name}/?${Query_params}&create=true`);
		}
	};

	const props = { load: state.load, isAuth: state.isAuth, handlerClick, thisIsFile, dictionary, isSoon, thisIsApp, serviceData, queryParams: Query_params };
	const OgImage = post["Top"].Main_image.data.attributes.url;

	return (
		<>
			<LandingSchema post={post} serviceData={serviceData} canonicalLocale={canonicalLocale} />
			<Layout mainClassName={`${styles.main} ${styles[colorScheme]} ${styles[locale]}`}>
				<OpenGraphTwitterCard title={Title} image={OgImage} description={Description} url={`/${Linck_name}`} canonical={`https://bgrem.ai/${canonicalLocale !== "en" ? canonicalLocale + "/" : ""}landings/${Linck_name}`} noindex={locale !== canonicalLocale} />
				<LandingMain post={post} props={props} />
				{!isSoon && servicesNameList[serviceData.url_name] && <FaqComponentNew pageName={servicesNameList[serviceData.url_name].faq} isPurpleBack={true} />}
				{showAuthModal && <AuthModal closeHandler={() => setShowAuthModal(false)} serviceName={isSoon ? "" : servicesNameList[serviceData.url_name].name} />}
			</Layout>
		</>

	);
}

export async function getServerSideProps({ req, locale, query, res }) {
	const cmsUrl = "https://cms.bgrem.ai/api/landings?filters[SEO][Linck_name][$eq]=";

	let params = "";

	const isDev = req.headers.host === "localhost:3000" || req.headers.host === "dev.bgrem.ai";

	if (isDev) params = `&publicationState=preview`;

	let resp = await axios.get(`${cmsUrl}${query.landings}&populate=deep,4&locale=${locale}${params}`);
	let canonicalLocale = locale;

	if (resp.data.data.length === 0) {
		resp = await axios.get(`${cmsUrl}${query.landings}&populate=deep,4&locale=en${params}`);
		canonicalLocale = "en";
	}

	if (resp.data.data[0] === undefined) {
		res.setHeader("location", "/landings");
		res.statusCode = 302;
		res.end();
		return;
	}

	const post = resp.data.data[0];

	return { props: { post: post.attributes, canonicalLocale, locale } };
}
